import { mode } from "@chakra-ui/theme-tools";
import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
  fonts: {
    // heading: "Heading Font Name",
    body: "Mulish",
  },
  styles: {
    global: props => ({
      body: {
        bg: mode("white", "black")(props),
      },
    }),
  },
  components: {
    Badge: {
      baseStyle: {
        fontSize: "9px",
        letterSpacing: "0.34em",
        padding: "5px 14px",
      },
    },
    Input: {
      parts: ["field"],
      baseStyle: {
        border: 0,
        borderRadius: 0,
        field: {
          color: "black",
        },
      },
      outline: {
        background: "white",
        borderRadius: 0,
      },
    },
    Select: {
      parts: ["field"],
      baseStyle: {
        border: 0,
        borderRadius: 0,
        field: {
          color: "black",
        },
      },
    },
    InputGroup: {
      baseStyle: {
        borderRadius: 0,
      },
    },
    Modal: {
      baseStyle: {
        dialogContainer: {
          "@supports(height: -webkit-fill-available)": {},
        },
      },
    },
    Tabs: {
      parts: ["tab"],
      baseStyle: ({ colorMode }) => ({
        tab: {
          fontSize: "12px",
          marginX: "15px",
          paddingY: "13px",
          color:
            colorMode === "light" ? "black !important" : "white !important",
          _selected: {
            fontWeight: 700,
          },
        },
      }),
    },
    Button: {
      baseStyle: {
        borderRadius: 0,
      },
      variants: {
        solid: ({ colorMode }) => ({
          fontWeight: 700,
          background: colorMode === "light" ? "black" : "white",
          color: colorMode === "light" ? "white" : "black",
          _hover: {
            background: colorMode === "light" ? "black" : "white",
          },
        }),
        outline: ({ colorMode }) => ({
          borderRadius: 0,
          borderWidth: "2px",
          fontWeight: 700,
          background: colorMode === "light" ? "white" : "black",
          color: colorMode === "light" ? "black" : "white",
          borderColor: colorMode === "light" ? "black" : "white",
          _hover: {
            background: colorMode === "light" ? "white" : "black",
          },
        }),
      },
    },
  },
});

export default theme;

// // example theme object
// export default {
//     fonts: {
//       body: "system-ui, sans-serif",
//       heading: "Georgia, serif",
//       mono: "Menlo, monospace",
//     },
//     fontSizes: {
//       xs: "0.75rem",
//       sm: "0.875rem",
//       md: "1rem",
//       lg: "1.125rem",
//       xl: "1.25rem",
//       "2xl": "1.5rem",
//       "3xl": "1.875rem",
//       "4xl": "2.25rem",
//       "5xl": "3rem",
//       "6xl": "3.75rem",
//       "7xl": "4.5rem",
//       "8xl": "6rem",
//       "9xl": "8rem",
//     },
//     fontWeights: {
//       hairline: 100,
//       thin: 200,
//       light: 300,
//       normal: 400,
//       medium: 500,
//       semibold: 600,
//       bold: 700,
//       extrabold: 800,
//       black: 900,
//     },
//     lineHeights: {
//       normal: "normal",
//       none: 1,
//       shorter: 1.25,
//       short: 1.375,
//       base: 1.5,
//       tall: 1.625,
//       taller: "2",
//       "3": ".75rem",
//       "4": "1rem",
//       "5": "1.25rem",
//       "6": "1.5rem",
//       "7": "1.75rem",
//       "8": "2rem",
//       "9": "2.25rem",
//       "10": "2.5rem",
//     },
//     letterSpacings: {
//       tighter: "-0.05em",
//       tight: "-0.025em",
//       normal: "0",
//       wide: "0.025em",
//       wider: "0.05em",
//       widest: "0.1em",
//     },
//   };
